import { PlaySound } from "@common/sound/PlaySound"
import React, {
    forwardRef,
    useCallback,
    useImperativeHandle,
    useRef,
} from "react"

let currentRef = null

export const PlaySoundComponent = forwardRef((props, ref) => {
    const playSoundRef = useRef()

    useImperativeHandle(
        ref,
        useCallback(
            () => ({
                play: playSoundRef?.current?.play,
                stop: playSoundRef?.current?.stop,
            }),
            []
        )
    )
    return <PlaySound ref={playSoundRef} />
})

export function PlaySoundM(props) {
    const playSoundRef = useRef(null)

    const setRef = useCallback((ref) => {
        if (ref) {
            playSoundRef.current = ref
            currentRef = ref
        }
    }, [])

    return <PlaySoundComponent ref={setRef} {...props} />
}

PlaySoundM.play = (params) => {
    return currentRef?.play(params)
}

// Logic to stop
PlaySoundM.stop = () => {
    return currentRef?.stop()
}
